<template>
    <div>
        <div v-if="deviceWarranties" class="card dashboardWidget">
            <div class="card-header">
                <h2>Devices Warranties</h2>
            </div>

            <div class="card-body container-fluid">
                <dx-pie-chart :data-source="deviceWarranties" :palette="palette" @point-click="pointClickHandler($event)" @legend-click="legendClickHandler($event)" :legend="legend" :adaptiveLayout="adaptiveLayout" type="Doughnut">
                    <dx-series argument-field="title"
                               value-field="amount">
                        <dx-label :visible="true"
                                  :customize-text="formatLabel">
                            <dx-connector :visible="true" :width="1">

                            </dx-connector>
                        </dx-label>
                    </dx-series>
                </dx-pie-chart>
            </div>
        </div>
    </div>
</template>
<script>
    import LoadingAnimation from '@/components/general/LoadingAnimation.vue'
    import DxPieChart, {
        DxSize,
        DxSeries,
        DxLabel,
        DxConnector,
        DxExport
    } from 'devextreme-vue/pie-chart';


    export default {
        props: {
            deviceWarranties: {
                type: Array,
                default: () => { }
            }
        },
        components: {
            LoadingAnimation,
            DxPieChart,
            DxSize,
            DxSeries,
            DxLabel,
            DxConnector,
            DxExport
        },
        data: function () {
            return {
                devices: null,
                overflow: 'hidden',
                palette: ['#7fbf1a', '#FFB100', '#FF1E00', '#FFDA00'],
                legend: { horizontalAlignment: "left" },
                adaptiveLayout: {
                    width: 50,
                    height: 50,
                    keepLabels: false
                }
            }
        }, computed: {
            url: function () {
                return process.env.VUE_APP_DICE_URI
            },
        },
        methods: {
            pointClickHandler(warranty) {
                warranty = warranty.target.data.title
              
                //this.toggleVisibility(e.target);
                this.$router.push({ path:`/dice/devices/${warranty}`})

            },
            toggleVisibility(item) {
                item.isVisible() ? item.hide() : item.show();
            },
            legendClickHandler(e) {
                let arg = e.target,
                    item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];

                this.toggleVisibility(item);
            },
            formatLabel(pointInfo) {
                return `${pointInfo.argumentText}: ${pointInfo.valueText}`;
            }
        },
        created() {

        }
    }
</script>

<style scoped>
    .container-fluid {
        width: 100%;
        height: 100%
    }
</style>
